import React from 'react';
import PropTypes from 'prop-types';
import Parallax from 'parallax-js';
import UAParser from 'ua-parser-js';
import Leaf from './Leaf';

import './home-block.css';

const uaParser = new UAParser();
const browser = uaParser.getResult();
const isWebkit = browser.browser.name === 'WebKit';

class HomeBlock extends React.PureComponent {
  componentDidMount() {
    new Parallax(this.block);
  }

  render() {
    return (
      <div className={`block hero ${this.props.isShow && 'show'} ${isWebkit && 'webkit'}`}>
        <div className="cloud-block" ref={(block) => { this.block = block; }}>
          <div data-depth="0.10"><div className="cloud cloud-2" /></div>
          <div data-depth="0.40"><div className="cloud cloud-3" /></div>
          <div data-depth="0.30"><div className="cloud cloud-3-copy" /></div>
          <div data-depth="0.20"><div className="cloud cloud-3-copy-2" /></div>
          <div data-depth="0.40"><div className="cloud cloud-4" /></div>
          <div data-depth="0.20"><div className="cloud cloud-5" /></div>
        </div>
        <div className="container">
          <Leaf className="left">
            <div>網路熱門關鍵字搜索</div>
            <div>謠言指數五顆星</div>
          </Leaf>
          <Leaf className="right">
            <div>2017</div>
            <div>網路謠言史上第一疑案</div>
          </Leaf>
          <div className="analgesic-haunting">
            ANALGESIC  HAUNTING
          </div>
          <div className="head">
            <div className="block-parent head-block"><div className="img" /></div>
            <div className="block-parent slogan-block">
              <div className="stop" />
              <div className="hurt" />
              <div className="strange" />
              <div className="talk" />
            </div>
            <div className="sub-text">以訛傳訛 恐怖漫延</div>
            <div className="do-you-trust">
              <div>這些止痛藥的鬼話，你信嗎?</div>
              <div>立即收聽，包你嚇得「不藥不藥」！</div>
            </div>
          </div>
        </div>
        <a className="story-open" href="#sectionTwo">
          <div className="down">
            <div className="d" />
          </div>
          怪談放送中
          <div className="down">
            <div className="d" />
          </div>
        </a>
      </div>
    );
  }
}

HomeBlock.propTypes = {
  isShow: PropTypes.bool,
};

HomeBlock.defaultProps = {
  isShow: false,
};

export default HomeBlock;



// WEBPACK FOOTER //
// ./src/blocks/HomeBlock/index.js